import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=87286854&scoped=true"
import script from "./campaigns.js?vue&type=script&lang=js&external"
export * from "./campaigns.js?vue&type=script&lang=js&external"
import style0 from "./campaigns.scss?vue&type=style&index=0&id=87286854&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87286854",
  null
  
)

export default component.exports